import { render, staticRenderFns } from "./WeldingRobot.vue?vue&type=template&id=14f5701e&scoped=true&"
import script from "./WeldingRobot.vue?vue&type=script&lang=js&"
export * from "./WeldingRobot.vue?vue&type=script&lang=js&"
import style0 from "./WeldingRobot.vue?vue&type=style&index=0&id=14f5701e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f5701e",
  null
  
)

export default component.exports